module.exports = __webpack_public_path__ + "static/img/teaching_materials_icon.862ae353.png";